<ng-container *ngIf="{subscriptions: clientSubscriptionData | async} as $">
    <div class="">
        <!-- Subscription Details-->
        <div>
            <!-- Details -->

            <div class="-mb-3" *ngIf="!showSkeleton && hasUpgradeSubscription($.subscriptions)">
                <p-message severity="info" styleClass="relative" aria-label="subscription-upgrade-info-message" *ngIf="getSubscriptionDetails($.subscriptions) as data">
                        <div class="flex align-items-center w-full -my-2 md:m-0">
                            <i class="fa fa-info-circle text-xl"></i>
                            <p-skeleton *ngIf="showSkeleton" width="10rem" height="1.1rem" styleClass="mb-1"></p-skeleton>
                            <div
                                class="ml-3 text-sm"
                                *ngIf="$.subscriptions.upgrade_from_clt_subs_id > 0"
                                [innerHTML]="'SUBSCRIPTIONS.SUBS_UPGRADE_FROM_NAME' | translate : { name : data.name_primary_language } "
                                (click)="getSubscription(data.id)"
                            ></div>
                            <div
                                class="ml-3 text-sm"
                                *ngIf="$.subscriptions.upgrade_to_clt_subs_id > 0"
                                [innerHTML]="'SUBSCRIPTIONS.SUBS_UPGRADE_TO_NAME' | translate : { name : data.name_primary_language } "
                                (click)="getSubscription(data.id)"
                            ></div>
                        </div>
                </p-message>
            </div>

            <div class="surface-0 shadow-1 border-round text-sm p-3 relative overflow-hidden mt-2">
                <div class="bg-pink-500 p-2 absolute z-3 text-white text-center text-xs card-badge" *ngIf="hasUpgradeSubscription($.subscriptions)">
                    <strong>{{ 'SUBSCRIPTIONS.UPGRADED' | translate }}</strong>
                </div>

                <!-- Heading -->
                <div class="grid">
                    <div class="col-8 md:col-8">
                        <div class="flex" *ngIf="!showSkeleton">
                            <span class="surface-300 px-2 py-1 border-round text-600 border-1 border-600 text-xs uppercase mr-2" *ngIf="isNotRenewingStatus($.subscriptions.status)">
                                {{ 'SUBSCRIPTIONS.NOT_RENEWING' | translate }}
                            </span>
                            <span class="bg-blue-50 px-2 py-1 border-round text-primary border-1 border-primary text-xs mr-2 uppercase">
                                {{'POS.PLANTYPE.'+ $.subscriptions.subscription_category.toUpperCase() | translate}}
                            </span>
                            <span
                                *ngIf="!isNotRenewingStatus($.subscriptions.status)"
                                class="px-2 py-1 flex align-items-center justify-content-center border-round text-white text-xxs mr-3 uppercase"
                                [ngClass]="showSubscriptionStatus($.subscriptions.status)">
                                {{$.subscriptions.status}}
                            </span>
                            <span *ngIf="isNotRenewingStatus($.subscriptions.status)" class="px-2 py-1 flex align-items-center justify-content-center border-round text-white text-xxs uppercase mr-3 bg-green-500">
                                {{$.subscriptions.state | titlecase}}
                            </span>
                            <p-tag *ngIf="isPresalePurchased($.subscriptions)" styleClass="text-xxs font-normal uppercase bg-purple-500 font-bold white-space-nowrap mr-2">{{ 'TENANT.PRESALE' | translate }}</p-tag>
                            <span class="flex align-items-center">
                                <i class="fa fa-map-marker-alt text-xl text-600 mr-1"></i>
                                <span *ngIf="getTenant($.subscriptions.tenant_id) as tenant">{{tenant.name_primary_language || tenant.name_secondary_language}}</span>
                            </span>
                        </div>
                        <!-- Badges Skeleton -->
                        <div *ngIf="showSkeleton" class="flex flex-wrap align-items-center">
                            <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2"></p-skeleton>
                            <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2"></p-skeleton>
                            <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2"></p-skeleton>
                            <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2"></p-skeleton>
                        </div>
                        <!-- Badges Skeleton -->

                        <div *ngIf="!showSkeleton">
                            <h3 class="my-2 font-bold text-base md:text-lg">
                                <span class="inline-block mr-3">{{$.subscriptions.name_primary_language || $.subscriptions.name_secondary_language}}</span>
                                <span class="text-xs text-500">{{'SUBSCRIPTIONS.SUB' | translate}}{{$.subscriptions.id}}</span>
                            </h3>

                            <p class="mb-1 mt-2" *ngIf="!isRecurringSubscription($.subscriptions)">
                                <!-- {{'SUBSCRIPTIONS.MONTHLY-SUBSCRIPTIONS' | translate}} -->
                                <ng-container *ngFor="let membership of $.subscriptions.recurring_template_recurring_services; let i = index">
                                    <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round mx-2 my-1" *ngIf="membership.service_is_base_membership"> {{'SUBSCRIPTIONS.BASE-MEMEBERSHIP' | translate}} </span>
                                    <br class="md:hidden" />
                                    <span>{{membership.service_type_name_primary_language || membership.service_type_name_secondary_language}}</span>
                                    <span *ngIf="$.subscriptions.recurring_template_recurring_services.length > 0 && (($.subscriptions.recurring_template_recurring_services.length - 1) !== i)">+</span>
                                </ng-container>
                            </p>

                            <p class="mb-2 text-xs text-600" *ngIf="$.subscriptions.description_primary_language || $.subscriptions.description_secondary_language">
                                {{$.subscriptions.description_primary_language || $.subscriptions.description_secondary_language}}
                            </p>

                            <p class="mb-1 mt-2" *ngIf="isPayAsYouGoSubscription($.subscriptions)">
                                {{'SUBSCRIPTIONS.MONTHLY-SUBSCRIPTIONS' | translate}}
                                <ng-container *ngFor="let membership of $.subscriptions.recurring_template_recurring_services; let i = index">
                                    <span *ngIf="membership.service_category_name_primary_language">
                                        {{membership.service_category_name_primary_language || membership.service_category_name_secondary_language }}
                                    </span>
                                    <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round mx-2 my-1" *ngIf="membership.service_is_base_membership"> {{'SUBSCRIPTIONS.BASE-MEMEBERSHIP' | translate}} </span>
                                    <br class="md:hidden" />
                                    <span *ngIf="$.subscriptions.recurring_template_recurring_services.length > 0 && (($.subscriptions.recurring_template_recurring_services.length - 1) !== i)">, </span>
                                </ng-container>
                            </p>
                        </div>

                        <div *ngIf="showSkeleton">
                            <div class="flex align-items-center my-2">
                                <p-skeleton width="18rem" height="1.3rem" styleClass="mr-2"></p-skeleton>
                                <p-skeleton width="5rem" height="1.3rem"></p-skeleton>
                            </div>
                            <p-skeleton width="100%" height="1.1rem" styleClass="mb-2"></p-skeleton>
                            <p-skeleton width="100%" height="1.1rem" styleClass="mb-1"></p-skeleton>
                        </div>
                    </div>
                    <div
                        *ngIf="!showSkeleton && isRecurringSubscription($.subscriptions) && !isPayAsYouGoSubscription($.subscriptions)"
                        class="col-12 md:col-4 flex align-items-center md:justify-content-end line-height-1 mb-1 mt-5 md:mb-0 md:pr-8"
                    >
                        <div class="inline-block">
                            <strong class="text-lg line-height-1" *ngIf="!showSkeleton">{{$.subscriptions.recurring_revenue | currencyformat}} </strong>
                            <sub class="ml-1 mt-2" *ngIf="isRecurringSubscription($.subscriptions) && !showSkeleton">
                                / {{ ($.subscriptions.billing_interval_value> 1)? $.subscriptions.billing_interval_value.toString() : ""}} {{ 'POS.MEMBERSHIP_ADDON.' + getInterval($.subscriptions.billing_interval_value ,
                                $.subscriptions.billing_interval_type) | translate}}
                            </sub>
                            <div class="text-xs text-600 font-italic text-right" *ngIf="!showSkeleton">{{'SUBSCRIPTIONS.INCLU_TAX' | translate}}</div>
                            <p-skeleton *ngIf="showSkeleton" width="4rem" height="1.25rem"></p-skeleton>
                            <p-skeleton *ngIf="showSkeleton" width="2rem" height="1.1rem" styleClass="ml-1"></p-skeleton>
                        </div>
                    </div>

                    <div *ngIf="showSkeleton" class="col-12 md:col-4 flex align-items-center md:justify-content-end line-height-1 mb-1 mt-5 md:mb-0 md:pr-8">
                        <div class="inline-block">
                            <p-skeleton *ngIf="showSkeleton" width="4rem" height="1.25rem"></p-skeleton>
                            <p-skeleton *ngIf="showSkeleton" width="2rem" height="1.1rem" styleClass="ml-1"></p-skeleton>
                        </div>
                    </div>

                    <div class="absolute right-0 top-0 mt-2 mr-2 flex align-items-center justify-content-end" *ngIf="!showSkeleton">
                        <subscription-action-list
                            *ngIf="!showSkeleton"
                            [clientId]="clientId"
                            [tenantId]="tenantId"
                            [subscriptionId]="subscriptionId"
                            [subscription]="$.subscriptions"
                            [paymentTimelineData]="paymentTimelineData"
                            [showFreeDiscount]="true"
                            (emitEvents)="ActionsEmitEvents($event)"
                            (closeAddonEvent)="closeAddonSidebar($event)"
                        >
                        </subscription-action-list>
                    </div>
                    <div *ngIf="showSkeleton" class="absolute right-0 top-0 mt-4 mr-3">
                        <p-skeleton width="5.2rem" height="2rem"></p-skeleton>
                    </div>
                </div>
                <!-- Heading -->

                <!-- Content -->
                <div class="grid my-0" *ngIf="!showSkeleton">
                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-hand-holding-dollar mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.COMMITMENT-PAID' | translate}}</h6>
                                <strong class="block text-base line-height-1">
                                    {{$.subscriptions.billing_interval_completed | number}}
                                    <span class="font-normal"><span>/</span> {{$.subscriptions.contract_term | number}}</span>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div class="flex flex-column h-full">
                                <div class="flex-1 flex flex-column justify-content-center">
                                    <i class="fa fa-hourglass mb-2 text-lg line-height-1"></i>
                                    <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.BILLING-FREQUENCY' | translate}}</h6>
                                    <strong class="block text-base line-height-1">
                                        {{GetBillingFrequency($.subscriptions.billing_interval_type,$.subscriptions.billing_interval_value,$.subscriptions.bill_cycle_day)}}
                                    </strong>
                                </div>
                                <!-- Error Message -->
                                <div class="mt-2">
                                    <p-message severity="error" aria-label="subscription-contract-expiry-message" styleClass="w-full">
                                            <div class="flex align-items-center w-full text-xs" *ngIf="$.subscriptions.on_contract_expiry === 'ContractExpire'">
                                                <i class="fa fa-times-circle mr-2"></i>
                                                <div>{{'SUBSCRIPTIONS.ContractExpire' | translate}}</div>
                                            </div>
                                            <div class="flex align-items-center w-full text-xs" *ngIf="$.subscriptions.on_contract_expiry === 'ContractAutoRenew'">
                                                <i class="fa fa-times-circle mr-2"></i>
                                                <div>{{'SUBSCRIPTIONS.ContractAutoRenew' | translate}}</div>
                                            </div>
                                            <div class="flex align-items-center w-full text-xs" *ngIf="$.subscriptions.on_contract_expiry === 'ContractConvertsToPayAsYouGo'">
                                                <i class="fa fa-times-circle mr-2"></i>
                                                <div>{{'SUBSCRIPTIONS.ContractConvertsToPayAsYouGo' | translate}}</div>
                                            </div>
                                    </p-message>
                                </div>
                                <!-- Error Message -->
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-calendar-minus mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.CONTRACT-END' | translate}}</h6>
                                <strong class="block text-base line-height-1">{{$.subscriptions.end_date | datetimeformat:'mediumDate'}}</strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-calendar-plus mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.NEXT-BILLING-DATE' | translate}}</h6>
                                <strong class="block text-base line-height-1">{{$.subscriptions.next_charge_date | datetimeformat:'mediumDate'}}</strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-calendar-check mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.START-DATE' | translate}}</h6>
                                <strong class="block text-base line-height-1">{{$.subscriptions.start_date | datetimeformat:'mediumDate'}}</strong>
                                <p-button
                                    *ngIf="!isRecurringSubscription($.subscriptions)"
                                    [ngClass]="CanEditDates($.subscriptions.status) || isTenantPresale.value ?'opacity-40 pointer-events-none' :'' "
                                    [label]="'common.BUTTONS.BUTTON_TEXT_EDIT'| translate"
                                    icon="fa fa-pencil"
                                    (click)="showEditStartEndDate = true"
                                    styleClass="text-xs text-600 surface-0 p-button-outlined p-button-secondary border-400 py-1 px-2 ml-2"
                                >
                                </p-button>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="!isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-hand-holding-dollar mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-700 text-xs mb-2">{{'SUBSCRIPTIONS.END_DATE' | translate}}</h6>
                                <strong class="block text-base line-height-1">
                                    {{$.subscriptions.end_date | datetimeformat:'mediumDate'}}
                                </strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-calendar mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-gray-700 text-xs mb-2">{{'SUBSCRIPTIONS.SIGN-UP-DATE' | translate}}</h6>
                                <strong class="block text-base line-height-1">{{$.subscriptions.sign_up_date | datetimeformat:'mediumDate'}}</strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                     <!-- Card -->
                     <div class="col-6 xl:col-3" *ngIf="isRecurringSubscription($.subscriptions)" >
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <i class="fa fa-credit-card mb-2 text-lg line-height-1"></i>
                                <h6 class="font-medium text-gray-700 text-xs mb-2">{{'SUBSCRIPTIONS.AUTO_PAY' | translate}}</h6>
                                <div class="flex align-items-center justify-content-center">
                                    <p-message class="text-xs" icon="fa fa-check-circle" *ngIf="$.subscriptions.feature_is_cash_recurring" severity="success" aria-label="subscription-autopay-on-message">
                                        <div class="flex align-items-center justify-content-center">
                                            <span>Off</span>
                                        </div>
                                    </p-message>
                                    <p-message class="text-xs" icon="fa fa-times-circle" *ngIf="$.subscriptions.feature_is_cash_recurring === false" severity="info" aria-label="subscription-autopay-off-message">
                                        <div class="flex align-items-center justify-content-center">
                                            <span>On</span>
                                        </div>
                                    </p-message>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-12 md:col-3" *ngIf="isRecurringSubscription($.subscriptions) && $.subscriptions.primary_payment_method">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <p-button *ngIf="!showSkeleton" icon="fa fa-pen" styleClass="p-button-text text-primary absolute right-0 top-0"></p-button>
                            <div class="mb-2"><img src="assets/img/icons/icon-payment.svg" alt="Image" /></div>
                            <h6 class="text-xs mb-2 text-700 font-medium">{{'SUBSCRIPTIONS.PRIMARY_PAYMENT_METHOD' | translate}}</h6>

                            <div class="flex align-items-center justify-content-center text-sm">
                                <strong class="flex align-items-center line-height-1" *ngIf="PaymentMethodDetails($.subscriptions.primary_payment_method) as paymentData">
                                    <img [src]="paymentData.img" alt="Payment Method Logo" class="mr-2" width="25px" />
                                    <span class="mx-2">{{paymentData.number}}</span>
                                    <i class="fa fa-check-circle" [class]="getTagStyle($.subscriptions.primary_payment_method.token_status)"></i>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->
                    <!-- Card -->
                    <div class="col-12 md:col-3" *ngIf="isRecurringSubscription($.subscriptions) && $.subscriptions.secondary_payment_method">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <p-button *ngIf="!showSkeleton" icon="fa fa-pen" styleClass="p-button-text text-primary absolute right-0 top-0"></p-button>
                            <div class="mb-2"><img src="assets/img/icons/icon-payment.svg" alt="Image" /></div>
                            <h6 class="text-xs mb-2 text-700 font-medium">{{'SUBSCRIPTIONS.SECONDARY_PAYMENT_METHOD' | translate}}</h6>

                            <div class="flex align-items-center justify-content-center text-sm">
                                <strong class="flex align-items-center line-height-1" *ngIf="PaymentMethodDetails($.subscriptions.secondary_payment_method) as paymentData">
                                    <img [src]="paymentData.img" alt="Payment Method Logo" class="mr-2" width="25px" />
                                    <span class="mx-2">{{paymentData.number}}</span>
                                    <i class="fa fa-check-circle" [class]="getTagStyle($.subscriptions.secondary_payment_method.token_status)"></i>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->

                    <!-- Card -->
                    <div class="col-12 md:col-3" *ngIf="false">
                        <div class="shadow-2 h-7rem rounded p-3 text-center relative h-full flex flex-column justify-content-center text-primary">
                            <div class="mb-2"><img src="assets/img/icons/icon-add-secondary-payment.svg" alt="Image" /></div>
                            <h6 class="text-sm mb-0 font-bold" *ngIf="$.subscriptions.primary_payment_method === null">{{'SUBSCRIPTIONS.ADD_PRI_PAYMENT_METHOD' | translate}}</h6>
                            <h6 class="text-sm mb-0 font-bold" *ngIf="$.subscriptions.secondary_payment_method === null">{{'SUBSCRIPTIONS.ADD_SEC_PAYMENT_METHOD' | translate}}</h6>
                        </div>
                    </div>
                    <!-- Card -->
                </div>

                <!-- Cards Skeleton -->
                <div *ngIf="showSkeleton" class="grid my-0">
                    <!-- Card -->
                    <div class="col-6 xl:col-3" *ngFor="let card of [1,2,3,4,5,6,7]">
                        <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                            <div>
                                <div class="mb-2"><p-skeleton width="2rem" height="2rem" styleClass="mx-auto"></p-skeleton></div>
                                <p-skeleton width="8rem" height="1.1rem" styleClass="mb-2 mx-auto"></p-skeleton>
                                <p-skeleton width="4rem" height="1rem" styleClass="mx-auto"></p-skeleton>
                            </div>
                        </div>
                    </div>
                    <!-- Card -->
                </div>
                <!-- Cards Skeleton -->
            </div>

            <!-- Details -->
            <div class="surface-0 text-sm mt-3">
                <app-subscription-services [subscription]="subscriptionById" [clientId]="clientId" [restrictToDateChange]="isTenantPresale.value" [tenantId]="tenantId"> </app-subscription-services>
            </div>
            <!-- Details -->

            <!-- Deposit Details -->
            <div class="mt-3 text-sm surface-0" *ngIf="!showSkeleton && subscriptionById && showDeposit">
                <app-data-grid [columnData]="depositTableData" [columns]="depositTablecolumns" [selectable]="false" [paginator]="false" [loading]="showSkeleton" [gridName]="'deposit-list'"> </app-data-grid>
            </div>
            <!-- Deposit Details -->

            <!-- Payment Timeline -->
            <payment-timeline *ngIf="!showSkeleton && paymentTimelineData.value && paymentTimelineData.value.length > 0" [PaymentTimelineData]="paymentTimelineData | async" [subscription]="subscriptionById"> </payment-timeline>
            <!-- Payment Timeline -->

            <!-- Invoices -->
            <div class="surface-0 text-sm mt-3">
                <!-- Header -->
                <div class="p-3 border-bottom-1 border-300 text-base">
                    <strong> {{'SUBSCRIPTIONS.INVOICES' | translate}}</strong>
                </div>
                <!-- Header -->
                <!-- Content -->
                <invoice-tab [clientId]="clientId" [tenantId]="tenantId" [subscriptionId]="subscriptionId" [showHeader]="false" [showTableActions]="!IsUpgraded" [loading]="showSkeleton"> </invoice-tab>
                <!-- Content -->
            </div>
            <!-- Invoices -->
        </div>
        <!-- Subscription Details-->
    </div>
</ng-container>



<!-- Invoice Modal  -->
<invoice-details *ngIf="showInvoicePopup" [showInvoice]="showInvoicePopup" [invoiceDetails]="invoiceDetails" [clientId]="clientId" [tenantId]="tenantId" (closeInvoice)="closeInvoicePopup($event)"> </invoice-details>
<!-- Invoice Modal -->

<subscription-start-end-date-edit
    *ngIf="showEditStartEndDate"
    [visible]="showEditStartEndDate"
    [clientId]="clientId"
    [tenantId]="tenantId"
    [subscription]="subscriptionById"
    [membershipId]="membershipId"
    (closeEvent)="closeDateChangeEvent($event)"
    (reloadSubscription)="reloadData($event)"
>
</subscription-start-end-date-edit>

<billing
    *ngIf="showBillingSidebar"
    [planSummarydata]="planSummarydataObject"
    [showPosBilling]="false"
    [showBilling]="true"
    closeOnEscape="false"
    (closeSidePopupMember)="HideBillingSummary()"
    (GoToClientSubscription)="GoToClientDetails($event)"
>
</billing>
